import { render, staticRenderFns } from "./InactiveEmployees.vue?vue&type=template&id=b9427422&scoped=true"
import script from "./InactiveEmployees.vue?vue&type=script&lang=js"
export * from "./InactiveEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9427422",
  null
  
)

export default component.exports